<template>
    <div style="color: black;">
    <sweet-modal blocking ref="modalInfo" class="modal" v-on:close="rejectConfirmCloseInfoModal" >
        <h1 class="modal__title">Expense Details</h1>
        <div class="modal__category">
            <div class="label">Expense No.: {{expenseNoModal}}</div>
        </div>
        <div class="modal__name">
            <div class="label"><i class="el-icon-date"></i>{{expenseDateModal}}</div>
        </div>
        <div class="modal__category">
            <div class="label">Category: {{expenseInventoryItemModal}}</div>
        </div>
        <div class="modal__amount">
            <h3>Total Amount: {{formatPrice(expenseAmountModal)}}</h3>
            <div>
                <el-tag v-if="expenseStatusModal" size="mini" class="tag" style="margin-right: 10px; width:100px; height:22px; text-align: center;" v-html="expenseStatusModal"></el-tag>
                <el-tag v-if="expenseReimbursableModal" size="mini" class="tag" style="margin-right: 10px; width:100px; height:22px; text-align: center;" v-html="expenseReimbursableModal"></el-tag>
                <el-tag v-if="expenseisBillableModal" size="mini" class="tag" style="width:100px; height:22px; text-align: center;" v-html="expenseisBillableModal"></el-tag>
                <div class="modal__history_btn_block">
                    <el-button size="mini"
                               type="primary"
                               plain
                               @click="$refs.historyModal.open()">History</el-button>
                </div>
            </div>
        </div>
        <div v-if="attachedCaModal" class="modal__ca">
            <h3><i class="el-icon-paperclip"></i> Attached Cash Advance</h3>
            <el-table
                    :data="attachedCaModal"
                    style="width: 100%;">
                <el-table-column
                        type="index"
                        width="50">
                </el-table-column>
                <el-table-column
                        prop="code"
                        label="No."
                        width="100">
                </el-table-column>
                <el-table-column
                        prop="cashAdvanceDate"
                        label="Date">
                    <template slot-scope="scope">
                        {{moment(scope.row.cashAdvanceDate.toString(), 'ddmmyyyy').format('DD MMM YYYY')}}
                    </template>
                </el-table-column>
                <el-table-column
                        prop="status"
                        label="Status">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.status === 1"
                                   size="mini"
                                   type="info"
                                   plain
                                   v-html="'Pending'">
                        </el-button>
                        <el-button v-if="scope.row.status === 2"
                                   size="mini"
                                   type="primary"
                                   plain
                                   v-html="state === 'requestProjectTaskExpenses' ? 'Requested' : 'Submited' ||
                                           state === 'requestBusinessUnitTaskExpenses' ? 'Requested' : 'Submited' ||
                                           state === 'requestEngagementTaskExpenses' ? 'Requested' : 'Submited'">
                            <!--{{scope.row.status}}-->
                        </el-button>
                        <el-button v-if="scope.row.status === 3"
                                   size="mini"
                                   type="success"
                                   plain
                                   v-html="'Approved'">
                        </el-button>
                        <el-button v-if="scope.row.status === 4"
                                   size="mini"
                                   type="danger"
                                   plain
                                   v-html="'Rejected'">
                        </el-button>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="amount"
                        label="Amount"
                        width="100">
                    <template slot-scope="scope">
                        {{formatPrice(scope.row.amount)}}
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-row :span="24" class="modal__bottom">
            <el-col :span="12">
                <b>Vendor : </b><span>{{expenseVendorModal}}</span>
            </el-col>
            <el-col :span="12">
                <b>Client : </b><span>{{expenseClientModal}}</span>
            </el-col>
        </el-row>
        <el-row :span="24" class="modal__bottom">
            <el-col :span="12">
                <b>Payment Method : </b><span>{{expensePaymentMethodModal}}</span>
            </el-col>
            <el-col :span="12">
                <b>Tax : </b><span>{{expenseTaxModal}}</span>
            </el-col>
        </el-row>
        <el-row :span="24" class="modal__bottom">
            <el-col :span="12">
                <b>{{labelName}} : </b><span>{{expenseProjectModal}}</span>
            </el-col>
            <el-col :span="12">
                <b>Task : </b><span>{{expenseProjectTaskModal}}</span>
            </el-col>
        </el-row>
        <el-row :span="24" class="modal__bottom">
            <el-col :span="12">
                <b>Group / Trip Name : </b><span>{{expenseGroupModal}}</span>
            </el-col>
            <el-col :span="12">
                <b>Vendor Tax Number: </b><span>{{expenseVendorTaxNumberModal}}</span>
            </el-col>
        </el-row>
        <el-row v-if="expenseFileModal" class="modal__bottom">
            <el-col :span="20">
                <div><b>File : </b>{{expenseFileModal.baseName}}</div>
            </el-col>
            <el-col :span="4">
                <el-button @click="viewFile(expenseFileModal.url)" type="warning" icon="el-icon-view" size="mini" plain></el-button>
            </el-col>
        </el-row>
        <el-row :span="24" class="modal__bottom">
            <b>Notes: </b><span>{{expenseNotesModal}}</span>
        </el-row>
        <div v-if="expenseStatusModal === 'Submited' && isLeader">
            <el-row :span="24" class="modal__bottom">
                <el-button
                        size="mini"
                        type="success"
                        plain
                        @click="handleApprove(activeCompanyrejectConfirmId, activeProjectId, activeTaskId, activeExpenseId, state)">Approve</el-button>
                <el-button
                        size="mini"
                        type="danger"
                        plain
                        @click="$refs.rejectConfirm.open()">Reject</el-button>
            </el-row>
        </div>
    </sweet-modal>
        <sweet-modal blocking ref="historyModal">
            <h3>History</h3>
            <div class="history-block">
                <div v-if="projectTaskExpenseHistoryList.length > 0">
                    <div v-for="item in projectTaskExpenseHistoryList" :key="item.id" :span="24">
                        <!--IF PROJECT OPEN-->
                        <div v-if="item.projectTaskHistory">
                            <div class="history-item-block" v-if="item.projectTaskHistory.action === 'rejectProjectTaskExpense' || item.projectTaskHistory.action === 'rejectProjectTaskExpenseRequest'">
                                <el-row>
                                    <el-col :span="6">
                                        <el-tag type="danger" size="small">Rejected</el-tag>
                                    </el-col>
                                    <el-col :span="10">
                                        {{moment(item.projectTaskHistory.createDate.toString(), 'X').format('lll')}}
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <b>Reason:</b><br>
                                    {{item.projectTaskHistory.params.description}}
                                </el-row>
                            </div>
                            <div class="history-item-block" v-if="item.projectTaskHistory.action === 'createProjectTaskExpense' || item.projectTaskHistory.action === 'createProjectTaskExpenseRequest'">
                                <el-row>
                                    <el-col :span="6">
                                        <el-tag size="small">Created</el-tag>
                                    </el-col>
                                    <el-col :span="10">
                                        {{moment(item.projectTaskHistory.createDate.toString(), 'X').format('lll')}}
                                    </el-col>
                                </el-row>
                            </div>
                            <div class="history-item-block" v-if="item.projectTaskHistory.action === 'submitProjectTaskExpense' || item.projectTaskHistory.action === 'submitProjectTaskExpenseRequest'">
                                <el-row>
                                    <el-col :span="6">
                                        <el-tag size="small">Submited</el-tag>
                                    </el-col>
                                    <el-col :span="10">
                                        {{moment(item.projectTaskHistory.createDate.toString(), 'X').format('lll')}}
                                    </el-col>
                                </el-row>
                            </div>
                            <div class="history-item-block" v-if="item.projectTaskHistory.action === 'approveProjectTaskExpense' || item.projectTaskHistory.action === 'approveProjectTaskExpenseRequest'">
                                <el-row>
                                    <el-col :span="6">
                                        <el-tag type="success" size="small">Approved</el-tag>
                                    </el-col>
                                    <el-col :span="10">
                                        {{moment(item.projectTaskHistory.createDate.toString(), 'X').format('lll')}}
                                    </el-col>
                                </el-row>
                            </div>

                            <!--&lt;!&ndash;REQUEST APPROVE&ndash;&gt;-->
                            <!--<div class="history-item-block" v-if="item.projectTaskHistory.action === 'approveProjectTaskExpenseRequest'">-->
                                <!--<el-row>-->
                                    <!--<el-col :span="6">-->
                                        <!--<el-tag type="success" size="small">Approved</el-tag>-->
                                    <!--</el-col>-->
                                    <!--<el-col :span="10">-->
                                        <!--{{moment(item.projectTaskHistory.createDate.toString(), 'X').format('DD MMM YYYY')}}-->
                                    <!--</el-col>-->
                                <!--</el-row>-->
                            <!--</div>-->
                            <!--&lt;!&ndash;REQUEST APPROVE&ndash;&gt;-->

                        </div>
                        <!--IF ENGAGEMENT OPEN-->
                        <div v-if="item.engagementTaskHistory">
                            <div class="history-item-block" v-if="item.engagementTaskHistory.action === 'rejectEngagementExpense'">
                                <el-row>
                                    <el-col :span="6">
                                        <el-tag type="danger" size="small">Rejected</el-tag>
                                    </el-col>
                                    <el-col :span="10">
                                        {{moment(item.engagementTaskHistory.createDate.toString(), 'X').format('lll')}}
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <b>Reason:</b><br>
                                    {{item.engagementTaskHistory.params.description}}
                                </el-row>
                            </div>
                            <div class="history-item-block" v-if="item.engagementTaskHistory.action === 'createEngagementExpense'">
                                <el-row>
                                    <el-col :span="6">
                                        <el-tag size="small">Created</el-tag>
                                    </el-col>
                                    <el-col :span="10">
                                        {{moment(item.engagementTaskHistory.createDate.toString(), 'X').format('lll')}}
                                    </el-col>
                                </el-row>
                            </div>
                            <div class="history-item-block" v-if="item.engagementTaskHistory.action === 'submitEngagementExpense'">
                                <el-row>
                                    <el-col :span="6">
                                        <el-tag size="small">Submited</el-tag>
                                    </el-col>
                                    <el-col :span="10">
                                        {{moment(item.engagementTaskHistory.createDate.toString(), 'X').format('lll')}}
                                    </el-col>
                                </el-row>
                            </div>
                            <div class="history-item-block" v-if="item.engagementTaskHistory.action === 'approveEngagementExpense'">
                                <el-row>
                                    <el-col :span="6">
                                        <el-tag type="success" size="small">Approved</el-tag>
                                    </el-col>
                                    <el-col :span="10">
                                        {{moment(item.engagementTaskHistory.createDate.toString(), 'X').format('lll')}}
                                    </el-col>
                                </el-row>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </sweet-modal>
        <sweet-modal v-on:close="rejectConfirmClose"  blocking class="nested" ref="rejectConfirm">
            <h1 class="modal__title">Reason</h1>
            <el-input
                    type="textarea"
                    :rows="2"
                    placeholder="Description"
                    v-model="description">
            </el-input>
            <el-row :span="24" class="modal__bottom">
                <el-button
                        size="mini"
                        type="danger"
                        plain
                        @click="handleReject(activeCompanyId, activeProjectId, activeTaskId, activeExpenseId, state)">Reject</el-button>
            </el-row>
        </sweet-modal>
        <sweet-modal ref="expenseNotFound" icon="warning">
            <div class="task-not-found-block">
                <h3>Expense has been deleted</h3>
            </div>
        </sweet-modal>
    <!-- <sweet-modal class="nested" ref="nestedChild">
        <iframe class="iframe" :src="'https://docs.google.com/gview?url=' + fileUrl + '&embedded=true'" frameborder="0"></iframe>
    </sweet-modal> -->
        <div v-if="viewerType == 2">
            <div v-show="false" class="images" v-viewer="{movable: true}">
                <img :src="fileUrl" :key="fileUrl" />
            </div>
        </div>
        <div class="mod" v-if="viewerType == 3">
            <div @click="closeMod" class="mod__close">
                <span>x</span>
            </div>
            <Media
                    :kind="'video'"
                    :controls="true"
                    :src="fileUrl"
            >
            </Media>
        </div>
        <div class="mod" v-if="viewerType == 4">
            <div @click="closeMod" class="mod__close">
                <span>x</span>
            </div>
            <Media
                    :kind="'audio'"
                    :controls="true"
                    :src="fileUrl"
            >
            </Media>
        </div>
    </div>
</template>

<script>
  let moment = require('moment')
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
  import Media from '@dongido/vue-viaudio'

  import axios from 'axios'
  export default {
    name: 'expenseInfo',
    components: {
      SweetModal,

      Media
    },
    data(){
      return{
        labelName: '',
        description: '',
        expenseNoModal: '',
        activeCompanyId: '',
        activeProjectId: '',
        activeTaskId: '',
        activeExpenseId: '',
        activeNotificationId: '',
        moment:moment,
        expenseStatusModal: '',
        expenseDateModal: '',
        expenseInventoryItemModal: '',
        expenseAmountModal: '',
        attachedCaModal: '',
        expenseReimbursableModal: '',
        expenseisBillableModal: '',
        expenseVendorModal:'',
        expenseClientModal:'',
        expensePaymentMethodModal: '',
        expenseTaxModal:'',
        expenseProjectModal: '',
        expenseProjectTaskModal:'',
        expenseGroupModal:'',
        expenseVendorTaxNumberModal:'',
        expenseNotesModal:'',
        expenseFileModal: '',
        fileUrl: '',
        type: '',
        viewerType: '',
        // fromHeader: false,
        projectTaskExpenseHistoryList: [],
        state: '',
        isLeader: false
      }
    },
    methods:{
      viewFile(url) {
        this.fileUrl = url
        this.type = this.fileUrl.split('.').pop().toUpperCase()
        console.log('---', this.fileUrl, this.type);

        if (this.type == 'JPG' || this.type == 'JPEG' || this.type == 'PNG' || this.type == 'BMP') {
          this.viewerType = 2;
          setTimeout(() => {
            console.log('-----', this.$el);
            const viewer = this.$el.querySelector('.images').$viewer
            viewer.show()
          }, 300);
        } else if (this.type == 'AVI' || this.type == 'MP4' || this.type == 'MOV') {
          this.viewerType = 3;
          setTimeout(() => {
            // this.$refs.video.open();
          }, 300);
        } else if (this.type == 'WMA' || this.type == 'MP3' || this.type == 'WAV' || this.type == 'OGG' || this.type == 'M4A') {
          this.viewerType = 4;
          setTimeout(() => {
            // this.$refs.video.open();
          }, 300);
        } else {
          this.viewerType = 1;
          this.$refs.nestedChild.open();
        }
      },
      openModalInfo(companyId, projectId, projectTaskId, projectTaskExpenseId, state){
        this.activeCompanyId = companyId
        this.activeProjectId = projectId
        this.activeTaskId = projectTaskId
        this.activeExpenseId = projectTaskExpenseId
        // this.fromHeader = true
        this.state = state
        this.openModal(companyId, projectId, projectTaskId, projectTaskExpenseId, state)
      },
      openModal(companyId, projectId, projectTaskId, projectTaskExpenseId, state){
        let stateProjectId = ''
        let stateTaskId = ''
        let stateProjectTaskExpenseId = ''
        switch (state){
          case 'projectTaskExpenses':
            stateProjectId = 'projectId'
            stateTaskId = 'projectTaskId'
            stateProjectTaskExpenseId = 'projectTaskExpenseId'
            break;
          case 'engagementTaskExpenses':
            stateProjectId = 'engagementId'
            stateTaskId = 'engagementTaskId'
            stateProjectTaskExpenseId = 'engagementTaskExpenseId'
            break;
          case 'businessUnitTaskExpenses':
            stateProjectId = 'businessUnitId'
            stateTaskId = 'businessUnitTaskId'
            stateProjectTaskExpenseId = 'businessUnitTaskExpenseId'
            break;
          case 'requestProjectTaskExpenses':
            stateProjectId = 'projectId'
            stateTaskId = 'projectTaskId'
            stateProjectTaskExpenseId = 'projectTaskExpenseId'
            break;
          case 'requestEngagementTaskExpenses':
            stateProjectId = 'engagementId'
            stateTaskId = 'engagementTaskId'
            stateProjectTaskExpenseId = 'engagementTaskExpenseId'
            break;
          case 'requestBusinessUnitTaskExpenses':
            stateProjectId = 'businessUnitId'
            stateTaskId = 'businessUnitTaskId'
            stateProjectTaskExpenseId = 'businessUnitTaskExpenseId'
            break;
        }
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/${state}/info?companyId=${companyId}&${stateProjectId}=${projectId}&${stateTaskId}=${projectTaskId}&${stateProjectTaskExpenseId}=${projectTaskExpenseId}`)
          .then(response => {
            // this.expenseDateModal = moment(i.createDate.toString(), 'X').format('DD MMMM YYYY')
            let date = response.data.info.expenseDate.toString()
            if (date.length < 8) {
              this.expenseDateModal = '0' + date
            } else {
              this.expenseDateModal = response.data.info.expenseDate.toString()
            }
            this.expenseNoModal = response.data.info.code
            this.expenseDateModal = moment(this.expenseDateModal, "ddmmyyyy").format("D MMM YY")
            console.log(this.expenseDateModal)
            if (response.data.info.status === 1) {
              this.expenseStatusModal = 'Pending'
            } else if (response.data.info.status === 2) {
              this.expenseStatusModal = 'Submited'
            } else if (response.data.info.status === 3) {
              this.expenseStatusModal = 'Approved'
            } else if (response.data.info.status === 4) {
              this.expenseStatusModal = 'Rejected'
            }
            //if Project INFO
            if(response.data.info.project){
              this.labelName = 'Project'
              this.expenseProjectModal = response.data.info.project.name
              this.expenseInventoryItemModal = response.data.info.projectTaskExpenseInventoryItem.name
              if(response.data.info.projectTask){
                this.expenseProjectTaskModal = response.data.info.projectTask.name
              }
              if(response.data.info.projectTaskCashAdvance){
                this.attachedCaModal = [response.data.info.projectTaskCashAdvance]
              }
              this.projectTaskExpenseHistoryList = response.data.info.projectTaskExpenseHistoryList
              //if Engagement INFO
            }else if(response.data.info.engagement){
              this.labelName = 'Engagement'
              this.expenseProjectModal = response.data.info.engagement.name
              this.expenseInventoryItemModal = response.data.info.engagementExpenseInventoryItem.name
              if(response.data.info.engagementTask){
                this.expenseProjectTaskModal = response.data.info.engagementTask.name
              }
              this.projectTaskExpenseHistoryList = response.data.info.engagementExpenseHistoryList
              if(response.data.info.engagementTaskCashAdvance){
                this.attachedCaModal = [response.data.info.engagementTaskCashAdvance]
              }
            }
            //if Business Unit INFO
            else if(response.data.info.businessUnit){
              this.labelName = 'Business Unit'
              this.expenseProjectModal = response.data.info.businessUnit.name
              this.expenseInventoryItemModal = response.data.info.businessUnitExpenseInventoryItem.name
              if(response.data.info.businessUnitTask){
                this.expenseProjectTaskModal = response.data.info.businessUnitTask.name
              }
              this.projectTaskExpenseHistoryList = response.data.info.businessUnitExpenseHistoryList
              if(response.data.info.businessUnitTaskCashAdvance){
                this.attachedCaModal = [response.data.info.businessUnitTaskCashAdvance]
              }
            }


            this.expenseAmountModal = response.data.info.totalAmount
            if(response.data.info.reimbursable === 1){
              this.expenseReimbursableModal = "Reimbursable"
            }
            if(response.data.info.isBillable === 1){
              this.expenseisBillableModal = "Billable"
            }
            this.expenseVendorModal = response.data.info.companyVendor.name
            this.expenseClientModal = response.data.info.companyClient.name
            //CHECK IF PROJECT METHOD
            if(response.data.info.projectTaskExpensePaymentMethod !== null){
              this.expensePaymentMethodModal = response.data.info.projectTaskExpensePaymentMethod.name
            }
            if(response.data.info.projectTax !== null){
              this.expenseTaxModal = response.data.info.projectTax.name
            }

            this.expenseGroupModal = response.data.info.group
            this.expenseVendorTaxNumberModal = response.data.info.vendorTaxNo
            this.expenseNotesModal = response.data.info.notes
            if(response.data.info.file){
              this.expenseFileModal = response.data.info.file
            }
            this.isLeader = response.data.info.isLeader
            this.$refs.modalInfo.open()
          })
          .catch(error => {
            this.expenseNotFoundOpenModal()
            this.$emit('deleteNotification', this.activeNotificationId, 'deleteGeneral')
            console.log('An error occurred:', error);
          });
      },
      formatPrice(value) {
        let val = (value/1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      },
      handleApprove(companyId, activeProjectId, activeTaskId, activeExpenseId, state){
        let stateProjectId = ''
        let stateTaskId = ''
        let stateProjectTaskExpenseId = ''
        switch (state){
          case 'projectTaskExpenses':
            stateProjectId = 'projectId'
            stateTaskId = 'projectTaskId'
            stateProjectTaskExpenseId = 'projectTaskExpenseId'
            break;
          case 'engagementTaskExpenses':
            stateProjectId = 'engagementId'
            stateTaskId = 'engagementTaskId'
            stateProjectTaskExpenseId = 'engagementTaskExpenseId'
            break;
          case 'businessUnitTaskExpenses':
            stateProjectId = 'businessUnitId'
            stateTaskId = 'businessUnitTaskId'
            stateProjectTaskExpenseId = 'businessUnitTaskExpenseId'
            break;
          case 'requestProjectTaskExpenses':
            stateProjectId = 'projectId'
            stateTaskId = 'projectTaskId'
            stateProjectTaskExpenseId = 'projectTaskExpenseId'
            break;
          case 'requestEngagementTaskExpenses':
            stateProjectId = 'engagementId'
            stateTaskId = 'engagementTaskId'
            stateProjectTaskExpenseId = 'engagementTaskExpenseId'
            break;
          case 'requestBusinessUnitTaskExpenses':
            stateProjectId = 'businessUnitId'
            stateTaskId = 'businessUnitTaskId'
            stateProjectTaskExpenseId = 'businessUnitTaskExpenseId'
            break;
        }
        console.log(activeProjectId, activeTaskId, activeExpenseId)
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/${state}/approve?companyId=${companyId}&${stateProjectId}=${activeProjectId}&${stateTaskId}=${activeTaskId}&${stateProjectTaskExpenseId}=${activeExpenseId}`)
          .then(response => {
            this.$emit('deleteNotification', this.activeNotificationId)
            if(this.$route.name === 'expenses' && companyId == this.$route.query.companyId){
              this.$emit('refreshExpensePage', activeProjectId)
            }else if(this.$route.name === 'users' && companyId == this.$route.query.companyId){
              this.$emit('refreshUserPage', activeProjectId)
            }
            this.notification("Success", "Expense Approved", "success");
            this.$refs.modalInfo.close()
          }).catch(error =>{
        })
      },
      handleReject(companyId, activeProjectId, activeTaskId, activeExpenseId, state){
        let data = {
          description: this.description
        }
        let stateProjectId = ''
        let stateTaskId = ''
        let stateProjectTaskExpenseId = ''
        switch (state){
          case 'projectTaskExpenses':
            stateProjectId = 'projectId'
            stateTaskId = 'projectTaskId'
            stateProjectTaskExpenseId = 'projectTaskExpenseId'
            break;
          case 'engagementTaskExpenses':
            stateProjectId = 'engagementId'
            stateTaskId = 'engagementTaskId'
            stateProjectTaskExpenseId = 'engagementTaskExpenseId'
            break;
          case 'businessUnitTaskExpenses':
            stateProjectId = 'businessUnitId'
            stateTaskId = 'businessUnitTaskId'
            stateProjectTaskExpenseId = 'businessUnitTaskExpenseId'
            break;
          case 'requestProjectTaskExpenses':
            stateProjectId = 'projectId'
            stateTaskId = 'projectTaskId'
            stateProjectTaskExpenseId = 'projectTaskExpenseId'
            break;
          case 'requestEngagementTaskExpenses':
            stateProjectId = 'engagementId'
            stateTaskId = 'engagementTaskId'
            stateProjectTaskExpenseId = 'engagementTaskExpenseId'
            break;
          case 'requestBusinessUnitTaskExpenses':
            stateProjectId = 'businessUnitId'
            stateTaskId = 'businessUnitTaskId'
            stateProjectTaskExpenseId = 'businessUnitTaskExpenseId'
            break;
        }
        console.log(activeProjectId, activeTaskId, activeExpenseId)
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/${state}/reject?companyId=${companyId}&${stateProjectId}=${activeProjectId}&${stateTaskId}=${activeTaskId}&${stateProjectTaskExpenseId}=${activeExpenseId}`, data)
          .then(response => {
            this.$emit('deleteNotification', this.activeNotificationId)
            if(this.$route.name === 'expenses' && companyId == this.$route.query.companyId){
              this.$emit('refreshExpensePage', activeProjectId)
            }else if(this.$route.name === 'users' && companyId == this.$route.query.companyId){
              this.$emit('refreshUserPage', activeProjectId)
            }
            this.notification("Success", "Expense Rejected", "success");
            this.$refs.rejectConfirm.close()
            this.rejectConfirmCloseMain()
          }).catch(error =>{
        })
      },
      expenseNotFoundOpenModal(){
        this.$refs.expenseNotFound.open()
        setTimeout(() => {
          this.$refs.expenseNotFound.close()
        }, 2000)
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      },
      rejectConfirmClose(){
        this.description = ''
      },
      rejectConfirmCloseMain(){
       this.$refs.modalInfo.close()
      },
      rejectConfirmCloseInfoModal(){
        this.description =  '';
        this.expenseNoModal = '';
        this.expenseStatusModal = '';
        this.expenseDateModal = '';
        this.expenseInventoryItemModal = '';
        this.expenseAmountModal = '';
        this.expenseReimbursableModal = '';
        this.expenseisBillableModal = '';
        this.expenseVendorModal = '';
        this.expenseClientModal = '';
        this.expensePaymentMethodModal=  '';
        this.expenseTaxModal = '';
        this.expenseProjectModal = '';
        this.expenseProjectTaskModal = '';
        this.expenseGroupModal = '';
        this.expenseVendorTaxNumberModal = '';
        this.expenseNotesModal = '';
        this.expenseFileModal = '';
        this.attachedCaModal = '';
      }
    }
  }
</script>

<style lang="less" scoped>
    .modal__title{
        border-bottom: 1px solid #EBEEF5;
        padding-bottom: 10px;
    }
    .modal__amount{
        border-bottom: 1px solid #EBEEF5;
        padding-bottom: 10px;
    }
    .modal__ca{
        /*border-bottom: 1px solid #EBEEF5;*/
        /*padding-bottom: 10px;*/
    }
    .modal__bottom{
        margin-top:20px;
    }
    .task-not-found-block{
        text-align:center;
    }
    .history-item-block{
        padding-top: 10px;
        padding-bottom: 10px;
        border-top: 1px solid #EBEEF5;
        border-bottom: 1px solid #EBEEF5;
    }
    .modal__history_btn_block{
        margin-top:20px;
    }
    .iframe{
        width:640px;
        height:700px;
    }
</style>
